import React from "react";
import { BarChart3, Grid3x3 } from "lucide-react";

const ViewToggle = ({ value, onChange }) => {
  
  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-slate-100 p-1 text-xs font-medium">
      <button
        type="button"
        onClick={() => onChange("table")}
        aria-label="Table view"
        className={`flex items-center justify-center rounded-full px-3 py-1.5 transition ${
          value === "table"
            ? "bg-[#7e6ff5] text-white shadow"
            : "bg-slate-200 text-[#7e6ff5]"
        }`}
      >
        <Grid3x3 size={14} />
      </button>
      <button
        type="button"
        onClick={() => onChange("chart")}
        aria-label="Chart view"
        className={`flex items-center justify-center rounded-full px-3 py-1.5 transition ${
          value === "chart"
            ? "bg-[#7e6ff5] text-white shadow"
            : "bg-slate-200 text-[#7e6ff5]"
        }`}
      >
        <BarChart3 size={14} />
      </button>
    </div>
  );
};

export default ViewToggle;
